// 帮助中心公共弹窗
import * as types from '@/store/mutations-types'

// state
const state = {
  theme: '', // 主题
  editDetail: null // 编辑详情数据
}

// action

// getter

// mutations
const mutations = {
  [types.THEME] (state, theme) {
    state.theme = theme
  },
  [types.OPENEDIT] (state, editDetail) {
    state.editDetail = editDetail
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/help/help-doc-create.js